import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Scrollbars } from 'react-custom-scrollbars';
import ReactTooltip from 'react-tooltip';
import InfoBlue from '../../../../assets/img/info-blue.svg';
import LanguageIcon from '../../../../assets/img/language-icon.svg';

const Language = (props) => {
  const {
    classes, filters, isLoading, checkedListAll, handleLanguageFiltersTest,
  } = props;

  const [open, setOpen] = useState(!!(checkedListAll && checkedListAll.length > 0));
  const [languageFilters, setLanguageFilters] = useState([]);

  const compare = (a, b) => {
    const bandA = a.key;
    const bandB = b.key;

    let comparison = 0;
    if (bandA > bandB) {
      comparison = 1;
    } else if (bandA < bandB) {
      comparison = -1;
    }
    return comparison * 1;
  };

  useEffect(() => {
    const sortedFilters = filters && filters.sort(compare);
    setLanguageFilters(sortedFilters);
  }, [filters]);

  const handleClick = () => {
    setOpen(!open);
  };

  const renderLanguages = (languages) => languages.map((info) => {
    let checked = false;
    let list = '';
    if (checkedListAll && checkedListAll.indexOf(info.key) > -1) {
      checked = true;
    }
    if (info.key !== '') {
      list = (
        <ListItem button className={classes.nested} key={info.key}>
          <ListItemText className={classes.filterItem}>
            <FormControlLabel
              className={classes.checkBox}
              control={(
                <Checkbox
                  value={info.key}
                  classes={{
                    root: classes.checkBox,
                    checked: classes.checked,
                  }}
                  checked={checked}
                  onClick={!isLoading ? handleLanguageFiltersTest : undefined}
                  disabled={isLoading}
                  disableRipple
                />
              )}
              label={`${info.key} (${info.doc_count})`}
            />
          </ListItemText>
        </ListItem>
      );
    }
    return list;
  });

  return (
    <List className={classes.filterMenu}>
      <ListItem button onClick={handleClick} className={classes.filterHead}>
        <ListItemText>
          <img src={LanguageIcon} alt="" />
          {' '}
          Full text language
          <img data-for="languageInfo" data-event="click focus mouseover" data-tip className={classes.infoIcon} src={InfoBlue} alt="" />
          <ReactTooltip id="languageInfo" className={classNames(classes.reactTooltip, classes.reactTooltipClickableLink)} globalEventOff="mouseover" place="right" type="light" effect="solid">
            <span>
              The language of the original full-text document. You can change the language of this webpage using the language selector in the top right of the page to get translations of all the information in the Development Evidence Portal, including the titles and abstracts of all studies.
            </span>
          </ReactTooltip>
        </ListItemText>
        {
          open ? <i className="fa fa-caret-up" aria-hidden="true" /> : <i className="fa fa-caret-down" aria-hidden="true" />
        }
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit className={classes.filterMenuBlock}>
        <div className={classes.maxHeightScroll}>
          <Scrollbars autoHeight>
            <List component="div" disablePadding>
              {
                languageFilters
                  ? (
                    renderLanguages(languageFilters)
                  )
                  : (<span className={classes.noFiltersFound}>No filters for languages</span>)
              }
            </List>
          </Scrollbars>
        </div>
      </Collapse>
    </List>
  );
};

Language.defaultProps = {
  filters: null,
  isLoading: false,
  checkedListAll: null,
};

Language.propTypes = {
  classes: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  filters: PropTypes.arrayOf(PropTypes.object),
  handleLanguageFiltersTest: PropTypes.func.isRequired,
  checkedListAll: PropTypes.arrayOf(PropTypes.string),
};

export default Language;
